import React,{useEffect, useState} from 'react'
import {Container,Row,Col,Button,Table} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getCounters, removeCounter } from '../../../actions/countersActions'


export default function Counters() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true) 
    const {counters, loading, result} = useSelector(state=>state.counters) 
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(getCounters())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])  

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('counters.itsok'),
                    icon: 'error',
                    text: t('counters.'+result.message+'0') + result.count + t('counters.'+result.message+'1')
                })
                dispatch({
                    type: 'COUNTER_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('counters.letsok'),
                    icon: 'success',
                    text: t('counters.deletedcounter')
                })
                dispatch({
                    type: 'COUNTER_RESET_RESULT'
                })
            }
        }
    }, [result, dispatch, t])

    const deleteCounter = (idCounter) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeCounter(idCounter))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }
      
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('counters.editcounter')}</h1> 
                        <label className='mb-2'>{t('counters.selectcounter')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/counter`}>
                                <i className="fas fa-digital-tachograph"></i> {t('counters.new')}
                            </Button>
                        </Row>
                        <Table striped bordered hover responsive size="sm">
                            <tbody>
                                {counters?.map((datos,id) => (
                                    <tr key={id}>
                                    <td>{datos.name}</td>
                                        <td>{datos.description}</td>
                                        <td className='text-center'>
                                            <Button variant="outline-success" href={`/admin/checkcounter/`+datos._id}>
                                                {t('counters.checkregisters')}
                                            </Button>
                                        </td>
                                        <td className='text-center'>
                                            <Button variant="outline-info" href={`/admin/counter/`+datos._id}>
                                                <i className="fas fa-digital-tachograph"></i> <i className="fas fa-edit fa-sm"></i>
                                            </Button>
                                        </td>
                                        <td className='text-center'>
                                            <Button variant="outline-danger" onClick={() => deleteCounter(datos._id)}>
                                                <i className="fas fa-digital-tachograph"></i> <i className="fas fa-minus fa-sm"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}